import React, { createContext, useContext, useState } from "react";

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [navbarContent, setNavbarContent] = useState(null);

  return (
    <NavbarContext.Provider value={{ navbarContent, setNavbarContent }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => useContext(NavbarContext);